import router from './router';
import store from '../store/store';
import MicrofrontendLoader from '../helpers/microfrontend-loader';

// Login redirect
router.beforeEach(async (to, _from, next) => {
  if ((!store.getters.loggedIn || !localStorage.getItem('microserviceToken')) && !to.meta.anon) {
    store.commit('setMicroserviceToken', '');
    store.commit('setWhizeoToken', '');
    store.dispatch('removeExtensionToken');
    next(`/Login?ReturnUrl=${encodeURIComponent(to.path)}`);
  } else {
    next();
  }
});

// Select client guard
router.beforeEach(async (to, _from, next) => {
  if (!store.getters.isImpersonator && to.path.startsWith('/SelectClient')) {
    next('/Login');
  } else {
    next();
  }
});

// Select client redirect
router.beforeEach(async (to, _from, next) => {
  const unselectedImpersonator = store.getters.isImpersonator && !store.getters.isClient;
  const invalidPath = !to.meta.anon && !to.path.startsWith('/SelectClient');

  if (unselectedImpersonator && invalidPath) {
    next(`/SelectClient?ReturnUrl=${encodeURIComponent(to.path)}`);
  } else {
    next();
  }
});

// Redirect to homepage if user has no sufficient rights to open user management page
router.beforeEach(async (to, _from, next) => {
  const hasUserManagementClaim = store.getters.userPermissions.includes('user-management');
  const userManagementPath = to.path.startsWith('/Users');

  if (!hasUserManagementClaim && userManagementPath) {
    next('/Dashboard');
  } else {
    next();
  }
});

// Microfrontend loader
router.beforeEach(async (to, _from, next) => {
  try {
    if (to.path.startsWith('/ConversionTools') && (!store.getters.hasValidWhizeoToken || !localStorage.getItem('whizeoToken'))) {
      store.dispatch('notify', { title: 'Error', message: 'Conversion Tools isn’t available right now, please try again later' });
      next(to.path.startsWith('/Dashboard') ? '/PageNotFound' : '/Dashboard');
      return;
    }
    const nextPath = await MicrofrontendLoader.load(to);
    next(nextPath);
  } catch {
    store.dispatch('notify', { title: 'Error', message: 'There was a problem loading this page' });
  }
});

// Reload the page if impersonator token has changed in another tab
router.beforeEach(async (to, _from, next) => {
  if (!to.path.startsWith('/Login') && localStorage.getItem('microserviceToken') && store.getters.microserviceToken !== localStorage.getItem('microserviceToken')) {
    window.location.reload();
  }
  next();
});

// Experience redirect for CamapignFlow feature
router.beforeEach(async (to, _from, next) => {
  if (to.path.startsWith('/Experiences')) {
    const campaignFlow = Boolean(store.getters.hasClientFeature('CampaignFlow'));
    if (campaignFlow) {
      next('/Campaigns');
    }
  }
  next();
});

// Require feature
router.beforeEach(async (to, _from, next) => {
  if (!to.meta || !to.meta.feature) {
    next();
  } else {
    const valid = Boolean(store.getters.hasClientFeature(to.meta.feature));
    next(valid);
  }
});

// Document title setter
router.beforeEach(async (to, _from, next) => {
  const title = to.meta && to.meta.title;
  document.title = title ? `Webeo - ${to.meta.title}` : 'Webeo';
  next();
});

// First time tutorial
router.beforeEach(async (to, _from, next) => {
  if (to.path.startsWith('/Dashboard')
    && store.getters.userInfo.showTutorial
    && Boolean(store.getters.hasClientFeature('CampaignFlow'))
    && Boolean(store.getters.hasClientFeature('CampaignsUI'))) {
    store.dispatch('updateShowUserTutorial', true);
  }

  next();
});
